/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1TagTagidLangsId202,
  PutApiV1TagTagidLangsId400,
  PutApiV1TagTagidLangsId401,
  PutApiV1TagTagidLangsId404,
  PutApiV1TagTagidLangsId409,
  PutApiV1TagTagidLangsId500,
  PutApiV1TagTagidLangsIdMutationRequest,
  PutApiV1TagTagidLangsIdMutationResponse,
  PutApiV1TagTagidLangsIdPathParams,
} from "../../types/tagIdiomasController/PutApiV1TagTagidLangsId.ts";
import { tagLangViewModelSchema } from "../tagLangViewModelSchema.ts";
import { updateTagLangRequestViewModelSchema } from "../updateTagLangRequestViewModelSchema.ts";

export const putApiV1TagTagidLangsIdPathParamsSchema = z.object({
  tagId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1TagTagidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1TagTagidLangsId202Schema = z.lazy(
  () => tagLangViewModelSchema,
) as unknown as ToZod<PutApiV1TagTagidLangsId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1TagTagidLangsId400Schema =
  z.any() as unknown as ToZod<PutApiV1TagTagidLangsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1TagTagidLangsId401Schema =
  z.any() as unknown as ToZod<PutApiV1TagTagidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1TagTagidLangsId404Schema =
  z.any() as unknown as ToZod<PutApiV1TagTagidLangsId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1TagTagidLangsId409Schema =
  z.any() as unknown as ToZod<PutApiV1TagTagidLangsId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1TagTagidLangsId500Schema =
  z.any() as unknown as ToZod<PutApiV1TagTagidLangsId500>;

export const putApiV1TagTagidLangsIdMutationRequestSchema = z.lazy(
  () => updateTagLangRequestViewModelSchema,
) as unknown as ToZod<PutApiV1TagTagidLangsIdMutationRequest>;

export const putApiV1TagTagidLangsIdMutationResponseSchema = z.lazy(
  () => putApiV1TagTagidLangsId202Schema,
) as unknown as ToZod<PutApiV1TagTagidLangsIdMutationResponse>;
